<style src="./style.scss">
</style>

<script>
  import Icon from "svelte-icon";
  import CheckedIcon from "@assets/icons/checked.svg";

  export let label;
  export let name;
  export let id;
  export let checked = false;
  export let handleChange = () => null;

  function onChange() {
    checked = !checked;

    handleChange(checked);
  }
</script>

<div class="checkbox">
  {#if checked}
    <div on:click="{onChange}">
      <Icon data="{CheckedIcon}" stroke="#fff" fill="#fff" size="12px" />
    </div>
  {/if}

  <input
    class="checkbox__item"
    type="checkbox"
    id="{id}"
    name="{name}"
    checked="{checked}"
    on:change="{onChange}" />
  <label for="{id}">{label}</label>
</div>
